(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["newsletter"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    var closeButton = event.target.closest('[data-newsletter-toast-close]');
    if (!closeButton) return;

    var toast = closeButton.closest('[data-newsletter-toast]');
    if (toast) {
      toast.hidden = true;
    }
  });

  var newsletterSubmitKey = 'oneFlavorNewsletterSubmitted';

  function hideNewsletterToasts() {
    document.querySelectorAll('[data-newsletter-toast]').forEach(function(toast) {
      toast.hidden = true;
    });
  }

  function showNewsletterToast(toast) {
    if (!toast) return;
    toast.hidden = false;
    toast.focus({ preventScroll: true });
    window.setTimeout(function() {
      toast.hidden = true;
    }, 7000);
  }

  document.addEventListener('submit', function(event) {
    var form = event.target.closest('[data-newsletter-form]');
    if (!form || !window.sessionStorage) return;
    sessionStorage.setItem(newsletterSubmitKey, 'true');
  });

  window.addEventListener('load', function() {
    var url = new URL(window.location.href);
    var hasNewsletterSuccess = url.searchParams.get('customer_posted') === 'true';
    var hasSubmitted = window.sessionStorage && sessionStorage.getItem(newsletterSubmitKey) === 'true';

    if (window.sessionStorage && hasSubmitted) {
      sessionStorage.removeItem(newsletterSubmitKey);
    }

    if (!hasNewsletterSuccess && !hasSubmitted) return;

    var toast = document.querySelector('[data-newsletter-toast]');
    if (toast && !toast.hidden) {
      showNewsletterToast(toast);
    }

    if (hasNewsletterSuccess) {
      url.searchParams.delete('customer_posted');
      history.replaceState(null, '', url.pathname + url.search + url.hash);
    }

    if (window.location.hash === '#contact_form') {
      history.replaceState(null, '', window.location.pathname + window.location.search);
    }

    if (hasSubmitted) {
      window.requestAnimationFrame(function() {
        var form = document.querySelector('[data-newsletter-form]');
        if (form) {
          form.scrollIntoView({ block: 'center', behavior: 'auto' });
        }
      });
    }
  });

  window.setTimeout(hideNewsletterToasts, 7000);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url).then(response => response.text()).then(text => {
      const html = document.createElement('div');
      html.innerHTML = text;
      const recommendations = html.querySelector('.product-recommendations');

      if (recommendations && recommendations.innerHTML.trim().length) {
        productRecommendationsSection.innerHTML = recommendations.innerHTML;
        // Rewire carousel arrows from the fetched markup
        productRecommendationsSection.querySelectorAll('script').forEach((old) => {
          const s = document.createElement('script');
          s.textContent = old.textContent;
          old.parentNode.replaceChild(s, old);
        });
      }
    }).catch(e => {
      console.error(e);
    });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  if (productRecommendationsSection) {
    const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});
    observer.observe(productRecommendationsSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-testimonials-carousel"] && !Shopify.designMode) return;
  try {
    
  class VideoCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-carousel-track]');
      this.cards = Array.from(this.querySelectorAll('[data-video-card]'));
      this.inlineVideos = [];
      this.prevButton = this.querySelector('.scroll-button-prev');
      this.nextButton = this.querySelector('.scroll-button-next');
      this.floatingPlayer = this.querySelector('[data-floating-player]');
      this.floatingMedia = this.querySelector('[data-floating-media]');
      this.closeButton = this.querySelector('[data-close-player]');
      this.activeFloatingVideo = null;
      this.videosLoaded = false;

      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => this.scrollByCard(-1));
      }
      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => this.scrollByCard(1));
      }
      this.cards.forEach((card) => {
        card.addEventListener('click', () => this.openFloatingPlayer(card));
      });
      if (this.closeButton) {
        this.closeButton.addEventListener('click', () => this.closeFloatingPlayer());
      }
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.closeFloatingPlayer();
      });

      this.createSectionObserver();
    }

    /* ---- Lazy-load: only create <video> elements when section is near viewport ---- */
    createSectionObserver() {
      if (!('IntersectionObserver' in window)) {
        this.loadVideos();
        return;
      }
      this.sectionObserver = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting && !this.videosLoaded) {
            this.loadVideos();
            this.sectionObserver.disconnect();
          }
        },
        { rootMargin: '200px' }
      );
      this.sectionObserver.observe(this);
    }

    /* ---- Build SD-480p <video> tags from the JSON source data ---- */
    loadVideos() {
      this.videosLoaded = true;
      this.cards.forEach((card, index) => {
        const sourcesScript = card.querySelector('[data-video-sources]');
        if (!sourcesScript) return;

        let sources;
        try { sources = JSON.parse(sourcesScript.textContent); } catch { return; }
        if (!sources.length) return;

        const poster = card.querySelector('img');
        const video = document.createElement('video');
        const sectionClass = this.className.replace('-wrap', '');
        video.className = sectionClass + '__video';
        video.autoplay = false;
        video.loop = true;
        video.muted = true;
        video.defaultMuted = true;
        video.playsInline = true;
        video.controls = false;
        video.preload = 'none';
        video.setAttribute('muted', '');
        video.setAttribute('playsinline', '');
        video.dataset.sourceId = `video-${index}`;
        video.dataset.hdSources = JSON.stringify(sources);

        sources.forEach((src) => {
          const sourceEl = document.createElement('source');
          sourceEl.src = src.sd;
          sourceEl.type = src.type;
          video.appendChild(sourceEl);
        });

        /* Keep the poster visible until the video has a frame to show */
        if (poster) {
          poster.style.position = 'absolute';
          poster.style.inset = '0';
          poster.style.zIndex = '1';
          video.addEventListener('playing', () => {
            poster.remove();
          }, { once: true });
        }
        card.prepend(video);
        this.inlineVideos.push(video);
      });

      this.createCardObserver();
    }

    /* ---- Play/pause individual cards based on visibility ---- */
    createCardObserver() {
      if (!('IntersectionObserver' in window)) {
        this.inlineVideos.forEach((v) => { v.preload = 'auto'; v.play().catch(() => {}); });
        return;
      }
      this.cardObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const video = entry.target;
            if (entry.isIntersecting && entry.intersectionRatio > 0.5 && !this.floatingPlayerContains(video)) {
              video.preload = 'auto';
              video.play().catch(() => {});
            } else {
              video.pause();
            }
          });
        },
        { threshold: [0.25, 0.5, 0.9] }
      );
      this.inlineVideos.forEach((v) => this.cardObserver.observe(v));
    }

    floatingPlayerContains(video) {
      return this.activeFloatingVideo && this.activeFloatingVideo.dataset.sourceId === video.dataset.sourceId;
    }

    scrollByCard(direction) {
      if (!this.track) return;
      const firstCard = this.cards[0];
      const amount = firstCard ? firstCard.getBoundingClientRect().width + 22 : 320;
      this.track.scrollBy({ left: amount * direction, behavior: 'smooth' });
    }

    /* ---- Floating player uses full HD sources ---- */
    openFloatingPlayer(card) {
      const sourceVideo = card.querySelector('video');
      if (!sourceVideo || !this.floatingPlayer || !this.floatingMedia) return;

      this.inlineVideos.forEach((v) => v.pause());
      const closeButton = this.closeButton;
      this.floatingMedia.innerHTML = '';
      if (closeButton) this.floatingMedia.appendChild(closeButton);

      let hdSources;
      try { hdSources = JSON.parse(sourceVideo.dataset.hdSources || '[]'); } catch { hdSources = []; }

      const floatingVideo = document.createElement('video');
      floatingVideo.controls = true;
      floatingVideo.muted = false;
      floatingVideo.defaultMuted = false;
      floatingVideo.playsInline = true;
      floatingVideo.autoplay = true;
      floatingVideo.preload = 'metadata';
      floatingVideo.dataset.sourceId = sourceVideo.dataset.sourceId || '';

      if (hdSources.length) {
        hdSources.forEach((src) => {
          const s = document.createElement('source');
          s.src = src.hd;
          s.type = src.type;
          floatingVideo.appendChild(s);
        });
      } else {
        Array.from(sourceVideo.querySelectorAll('source')).forEach((s) => {
          floatingVideo.appendChild(s.cloneNode(true));
        });
      }

      this.floatingMedia.appendChild(floatingVideo);
      this.floatingPlayer.hidden = false;
      this.activeFloatingVideo = floatingVideo;
      floatingVideo.load();
      floatingVideo.play().catch(() => {});
    }

    closeFloatingPlayer() {
      if (!this.floatingPlayer || !this.floatingMedia) return;
      if (this.activeFloatingVideo) this.activeFloatingVideo.pause();
      this.floatingMedia.querySelectorAll('video').forEach((v) => v.remove());
      this.floatingPlayer.hidden = true;
      this.activeFloatingVideo = null;
      this.inlineVideos.forEach((video) => {
        const rect = video.getBoundingClientRect();
        if (rect.top < window.innerHeight && rect.bottom > 0 && rect.left < window.innerWidth && rect.right > 0) {
          video.play().catch(() => {});
        }
      });
    }
  }

  if (!customElements.get('video-carousel')) {
    customElements.define('video-carousel', VideoCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
